<template>
    <div class="controls" data-aos="fade-right" data-aos-easing="linear" data-aos-duration="0">
        <div class="controls_left">
            <div class="controls_left__title">
                <span>一键执行</span>
                <controleDialog @refresh="getColdMonitorlist" :list="deviceList"></controleDialog>
            </div>
            <div class="controls_left__content">
                <div class="controls_left__content_item" v-for="item, index in gridData" :key="index">
                    <div @click="batchSendCommands(item)"
                        style="text-overflow: ellipsis; white-space: nowrap;width: 70%;overflow: hidden;">
                        {{ item.T_name }}
                    </div>
                    <controleDialog titles="编辑" style="flex-shrink: 0;" @refresh="getColdMonitorlist" :row="item"
                        :list="deviceList"></controleDialog>
                </div>
            </div>
        </div>
        <div class="controls_conter">
            <div class="controls_conter_mains">
                <div class="controls_conter_mains__conter" v-for="item, index in deviceList" :key="index">
                    <template v-if="hasNonEmptyDataJson(item.arrJson)">
                        <div class="controls_conter_mains__conter_title">
                            {{ item.T_tab }}
                        </div>
                        <div class="controls_conter_mains__conter_item" v-for="j, index in item.arrJson" :key="index">
                            <template v-if="j.T_ProductID == 'NEXIgzTydhbYpGVDuaUZjqKMQJRPnCFf'"><!--空调控制 -->
                                <div class="controls_conter_mains_item" v-for="p, i in j.T_dataJson" :key="i">
                                    <div class="controls_conter_mains_item_class" @click="onclickSend(p)"
                                        v-if="p.d_show || p.d_show == 1">
                                        <div class="controls_conter_mains_item_class_title">
                                            {{ p[p.names] }}
                                        </div>
                                        <div class="controls_conter_mains_item_class_conter">
                                            <div class="controls_conter_mains_item_class_conter_yuan"
                                                :class="(p.T_online == 1) && (p[p.swiperName] == 1) ? '' : 'stopSearch'">
                                                <img :src="getImagePath(p)" alt="">
                                            </div>
                                            <div :style="{ color: p.T_online != 1 ? '#4d6281' : p[p.swiperName] == 1 ? '#00bfff' : 'red' }"
                                                class="controls_conter_mains_item_class_conter_text">
                                                {{ p.T_online != 1 ? '离线' : p[p.swiperName] == 1 ? '开启' :
                                                    p[p.swiperName] == 0 ? '关闭' : '失败' }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-if="j.T_ProductID == 'mMuzdHnTBhaSlcAZQJPVjgKXqCvNYbIr'"><!--红外控制 -->
                                <div>红外控制</div>
                            </template>
                        </div>
                    </template>
                </div>
            </div>
        </div>

        <el-dialog custom-class="customStyle" width="40%" title="控制情况" append-to-body :visible.sync="innerVisible"
            destroy-on-close>
            <el-table class="tableStyle innerTable" :data="successTable" height="600">
                <el-table-column type="index" width="55"></el-table-column>
                <el-table-column label="设备名称">
                    <template slot-scope="scope">
                        {{ scope.row[scope.row.names] }}
                    </template>
                </el-table-column>
                <el-table-column label="开/关">
                    <template slot-scope="scope">
                        {{ scope.row[scope.row.swiperName] == 1 ? '开启' : '关闭' }}
                    </template>
                </el-table-column>
                <el-table-column label="控制状态">
                    <template slot-scope="scope">
                        <div :style="{ color: (scope.row.flag ? '#07c160' : 'red') }">
                            {{ scope.row.flag ? '成功' : '失败' }}
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            </el-table-column>
        </el-dialog>



    </div>
</template>

<script>
import verticalMenu from "./modules/verticalMenu.vue";
import controleDialog from "./modules/controleDialog.vue";
import { MovingFun, arrMov } from "./js/MovingData.js";

import {
    getColdMonitorlist,
    getGroupList,
    getdeviceGetFun
} from "./js/MovingRingApi.js";


export default {
    components: { verticalMenu, controleDialog },
    name: "",
    data() {
        return {
            innerVisible: false,
            gridData: [],//指令列表
            deviceList: [], //设备列表
            socket: null,// webSocket
            heartbeatInterval: null, // 心跳定时器
            isFlag: false,//作为是否正在控制中，true还在进行中 false未进行
            isItem: null,//当前正在控制的项
            loadings: null,//加载蒙版
            successTable: null,//成功表格
            isObject: null,//判断当前执行项的原始数据
        };
    },
    created() { },
    mounted() {
        this.getColdMonitorlist()
        this.getGroupList()
    },
    beforeDestroy() {
        this.close(); // 组件销毁前关闭 WebSocket 连接
    },
    methods: {
        hasNonEmptyDataJson(arrJson) {
            for (let i = 0; i < arrJson.length; i++) {
                if (arrJson[i].T_dataJson && arrJson[i].T_dataJson.length !== 0) {
                    return true;
                }
            }
            return false;
        },
        async batchSendCommands(item) {
            this.$confirm(`一键执行【${item.T_name}】, 是否执行?`, '提示', {
                confirmButtonText: '立即执行',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.fetchFun(item)
            }).catch(() => { });
        },

        async fetchFun(item) {
            let arr = JSON.parse(item.T_text)
            this.loadings = this.$loading({
                lock: true,
                text: `请稍后...`,
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.successTable = []
            // 控制时停止心跳，执行完开始心跳
            clearInterval(this.heartbeatInterval)//心跳定时器
            this.heartbeatInterval = null//心跳定时器

            for (let j = 0; j < arr.length; j++) {
                let attempt = 0;
                this.isFlag = true;
                this.loadings.setText(`开始控制第【${j + 1}/${arr.length}】，请稍后...`);

                while (attempt < 3) {
                    this.mergeData(arr[j], 'all');
                    attempt++;
                    await new Promise(resolve => setTimeout(resolve, 3000));
                    if (!this.isFlag) {
                        break;
                    }
                }

                if (this.isFlag) {//控制失败
                    this.successTable.push({ ...arr[j], flag: false })
                } else {//控制成功
                    this.successTable.push({ ...arr[j], flag: true })
                }
            }
            this.loadings.close();// 关闭加载动画
            this.innerVisible = true
            // 控制完成后开始心跳
            this.startHeartbeat()
        },



        //单个控制
        async onclickSend(item) {
            if (item.T_online != 1) {
                this.$message.error('设备离线，无法控制')
                return
            }
            if (this.isFlag) {
                this.$message.warning('正在进行中，请稍等...')
                return
            }

            // 控制时停止心跳，执行完开始心跳
            clearInterval(this.heartbeatInterval)//心跳定时器
            this.heartbeatInterval = null//心跳定时器


            this.loadings = this.$loading({
                lock: true,
                text: '正在发送指令，请稍后...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.isFlag = true
            this.mergeData(item)
            let num = 3
            for (let i = 1; i <= num; i++) {
                await new Promise(resolve => setTimeout(resolve, 3000));
                if (!this.isFlag) {
                    this.$message.success('操作成功')
                    this.loadings.close();//关闭加载动画
                    this.startHeartbeat()//开始心跳
                    break;
                } else if (i === num) {
                    this.$message.error('控制失败')
                    this.loadings.close();//关闭加载动画
                    this.isFlag = false

                    this.startHeartbeat()//开始心跳
                } else {
                    this.loadings.setText(`尝试发送第【${i + 1}】次指令，请稍后...`);
                    this.mergeData(item)
                }
            }
        },
        //整理发送的数据
        mergeData(item, type) {//type等于all批量控制，状态不能改变，其他时0->1,1->0
            let obj = {
                type: 3,
                sn: item.T_sn,
                pass: item.T_password,
                json: {},
            }
            var inner = {}
            this.$set(inner, item.swiperName, type ? (item[item.swiperName]) : (item[item.swiperName] == 1 ? 0 : 1))
            this.$set(obj.json, item.keys, inner)
            console.log('单控', obj)
            this.isItem = obj//赋值当前控制项
            this.isObject = { ...item }
            this.send(obj)
        },
        init() {
            if (typeof (WebSocket) === "undefined") {
                alert("您的浏览器不支持socket")
            } else {
                // 实例化socket
                this.socket = new WebSocket('wss://cold.coldbaozhida.com/Cold_Monitor_AOIT/WS');
                // this.socket = new WebSocket("wss://uat.sssyin.cn/ws-reservation")
                // 监听socket连接 
                this.socket.onopen = this.open
                // 监听socket错误信息
                this.socket.onerror = this.error
                // 监听socket消息
                this.socket.onmessage = this.getMessage
                //监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
                window.onbeforeunload = () => {
                    this.socket.onclose = this.close
                };
                return this.socket
            }
        },
        // 连接成功事件,订阅设备所有设备
        open() {
            for (let i = 0; i < this.deviceList.length; i++) {
                for (let j = 0; j < this.deviceList[i].arrJson.length; j++) {
                    this.send({
                        type: 1,
                        sn: this.deviceList[i].arrJson[j].T_sn,
                        pass: this.deviceList[i].arrJson[j].T_password,
                        json: {}
                    })
                }
            }
            this.startHeartbeat() //心跳
        },
        //开始心跳
        startHeartbeat() {
            this.heartbeatInterval = setInterval(() => {
                for (let i = 0; i < this.deviceList.length; i++) {
                    for (let j = 0; j < this.deviceList[i].arrJson.length; j++) {
                        this.send({
                            type: 0,
                            sn: this.deviceList[i].arrJson[j].T_sn,
                            pass: this.deviceList[i].arrJson[j].T_password,
                            json: {}
                        })
                    }
                }
            }, 10000)
        },
        // 发送消息给被连接的服务端
        send(params) {
            this.socket.send(JSON.stringify(params))
        },
        // 错误事件
        error(error) {
            console.error("WebSocket 连接错误:", error);
        },
        // 接收消息事件
        getMessage(msg) {
            const reslut = JSON.parse(msg.data)
            if (!('msg' in reslut) && !('Msg' in reslut)) {//目前只针对空调控制
                console.log('控制成功', this.isObject, reslut);
                if (reslut.T_sn == this.isItem.sn) {
                    this.isFlag = false
                }
                // if(this.isObject){
                //     Object.keys(reslut).forEach(item=>{
                //         if(item==this.isObject.keys){
                //             console.log('找到key相同',item,this.isObject.keys)
                //             if(reslut[item][this.isObject.swiperName]!=this.isObject[this.isObject.swiperName]){
                //             }else{//返回值与控制前值不相等才算时成功
                //                 console.log('值不相等',reslut[item][this.isObject.swiperName],this.isObject[this.isObject.swiperName]);
                //             }
                //         }
                //     })
                // }
                for (let i = 0; i < this.deviceList.length; i++) {
                    let arrJson = this.deviceList[i].arrJson
                    for (let j = 0; j < arrJson.length; j++) {
                        if (reslut.T_sn == arrJson[j].T_sn) {
                            for (let o = 0; o < this.deviceList[i].arrJson[j].T_dataJson.length; o++) {
                                const key = this.deviceList[i].arrJson[j].T_dataJson[o].keys;
                                // 检查 obj 中是否存在对应的 key
                                if (reslut.hasOwnProperty(key)) {
                                    // 将 obj 中对应 key 的值合并到 arr 对应的对象中
                                    Object.assign(this.deviceList[i].arrJson[j].T_dataJson[o], reslut[key]);
                                }
                            }
                        }
                    }
                }
            } else if ('msg' in reslut) {//设备离线
                if (reslut.online) {
                    console.log('====设备离线上线',);
                    this.$notify({
                        type: reslut.online == 2 ? 'error' : 'success',
                        title: reslut.online == 2 ? '设备离线' : '设备上线',
                        message: reslut.msg
                    });
                    for (let i = 0; i < this.deviceList.length; i++) {
                        let arrJson = this.deviceList[i].arrJson
                        for (let j = 0; j < arrJson.length; j++) {
                            if (reslut.T_sn == arrJson[j].T_sn) {
                                this.deviceList[i].arrJson[j].T_dataJson.forEach(item => {
                                    item.T_online = reslut.online
                                });
                                this.deviceList[i].arrJson[j].T_online = reslut.online
                            }
                        }
                    }
                    console.log('完成', this.deviceList);
                }
            } else {//其他消息
                // console.log('其他消息')
            }
        },
        // 关闭连接事件
        close() {
            if (this.socket) {
                this.socket.close();
                this.socket = null;
                clearInterval(this.heartbeatInterval)//心跳定时器
                this.heartbeatInterval = null//心跳定时器
            }
        },
        //一键执行列表
        async getColdMonitorlist() {
            let res = await getColdMonitorlist({})
            this.gridData = res || []
        },
        //分组列表
        async getGroupList() {
            let res = await getGroupList({})
            let arr = [...res] || []
            let finalArr = []
            // 用于存储最终结果
            for (let item of arr) {
                let { T_sn } = item
                item.arrJson = []
                for (let i of T_sn) {
                    let reslut = await this.fetchGetDev(i)
                    if (reslut.Code == 200 && reslut.Data) {
                        item.arrJson.push(reslut.Data)
                    }
                }
                // 如果 arrJson 长度不为 0，将 item 添加到 finalArr
                if (item.arrJson.length > 0) {
                    finalArr.push(item);
                }
            }
            this.deviceList = finalArr
            this.$emit('input', finalArr)
            this.init()
        },
        //设备列表
        async fetchGetDev(sn) {
            return new Promise((reslove) => {
                getdeviceGetFun({ T_sn: sn }).then(res => {
                    if (res.Code == 200 && res.Data) {
                        let d = MovingFun(res || [])
                        reslove(d)
                    } else {
                        reslove(res)
                    }
                })
            })

        },
        // 根据 p 对象的值返回对应的图片路径
        getImagePath(p) {
            if (p.T_online !== 1) {
                return require('./img/lixian.png');
            } else {
                if (p[p.swiperName] == 1) {
                    return require('./img/stopSearch.png');
                } else if (p[p.swiperName] == 0) {
                    return require('./img/creico.png');
                }
            }
            return '';
        }
    }
};
</script>
<style lang="scss">
:root {
    --width: 280px;
}

.controls {
    flex: 1;
    overflow: hidden;
    display: flex;
    position: relative;
    border: 1px solid rgba(#00bfff, .2);
    box-sizing: border-box;
    padding: 20px;
    margin: 30px;

    &_left {
        flex-shrink: 0;
        width: 300px;
        background: url('./img/left-bg.png');
        background-size: 100% 100%;
        background-position: left;
        background-repeat: no-repeat;
        overflow: hidden;
        height: 100%;
        display: flex;
        flex-direction: column;

        &__title {
            height: 7%;
            font-size: 16px;
            font-weight: 600;
            color: #007bff;
            padding: 0 10px 0 30px;
            line-height: 20%;
            font-style: oblique;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        &__content {
            flex: 1;
            overflow: auto;
            padding: 0 10px;

            /* 隐藏 Chrome、Safari 和 Opera 的滚动条 */
            &::-webkit-scrollbar {
                display: none;
            }

            /* 隐藏 IE、Edge 和 Firefox 的滚动条 */
            -ms-overflow-style: none;
            /* IE 和 Edge */
            scrollbar-width: none;

            /* Firefox */
            &_item {
                height: 40px;
                line-height: 40px;
                font-size: 14px;
                font-weight: 500;
                margin-top: 10px;
                color: #007bff;
                background: linear-gradient(to right, rgba(0, 191, 255, 0.07), transparent);
                cursor: pointer;
                padding-left: 20px;
                display: flex;
                justify-content: space-between;
                align-items: center;

                &:hover {
                    background: linear-gradient(to right, rgba(0, 191, 255, 0.2), transparent);
                }
            }
        }
    }

    &_conter {
        flex: 1;
        margin-left: 20px;
        display: flex;
        flex-direction: column;
        overflow-y: auto;

        /* 隐藏 Chrome、Safari 和 Opera 的滚动条 */
        &::-webkit-scrollbar {
            display: none;
        }

        /* 隐藏 IE、Edge 和 Firefox 的滚动条 */
        -ms-overflow-style: none;
        /* IE 和 Edge */
        scrollbar-width: none;
        /* Firefox */
        border: 1px solid rgba(#00bfff, .2);
        box-sizing: border-box;

        &_mains {
            flex: 1;

            &__conter {
                &:not(:last-child) {
                    border-bottom: 1px solid rgba(#00bfff, .2);
                    box-sizing: border-box;
                }

                &_title {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    color: #007bff;
                    font-weight: bold;
                    font-size: 18px;
                    padding: 8px 20px;
                    // background: linear-gradient(to right, transparent 20%,rgba(#007bff,.1), transparent 80%);
                    background: linear-gradient(to right, rgba(#007bff, .1), transparent 80%);
                }

                &_item {
                    display: grid;
                    grid-gap: 60px;
                    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
                    padding: 40px 20px;
                }
            }
        }
    }

    &_right {
        flex-shrink: 0;
        width: 300px;
        background: url('./img/left-bg.png');
        background-size: 100% 100%;
        background-position: left;
        background-repeat: no-repeat;
        overflow: hidden;
        height: 100%;
        display: flex;
        flex-direction: column;

        &__title {
            height: 7%;
            font-size: 16px;
            font-weight: 600;
            color: #007bff;
            padding: 0 10px 0 30px;
            line-height: 20%;
            font-style: oblique;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        &__content {
            overflow: auto;
            padding: 0 10px;

            /* 隐藏 Chrome、Safari 和 Opera 的滚动条 */
            &::-webkit-scrollbar {
                display: none;
            }

            /* 隐藏 IE、Edge 和 Firefox 的滚动条 */
            -ms-overflow-style: none;
            /* IE 和 Edge */
            scrollbar-width: none;

            /* Firefox */
            &_item {
                height: 40px;
                line-height: 40px;
                font-size: 14px;
                font-weight: 500;
                margin-top: 10px;
                color: #007bff;
                background: linear-gradient(to right, rgba(0, 191, 255, 0.07), transparent);
                cursor: pointer;
                padding-left: 20px;

                &:hover {

                    background: linear-gradient(to right, rgba(0, 191, 255, 0.2), transparent);
                }
            }
        }
    }

}

.controls_conter_mains_item {
    &_class {
        min-height: 170px;
        display: flex;
        flex-direction: column;

        &_title {
            height: 30px;
            line-height: 30px;
            color: rgb(0, 191, 255);
            font-size: 12px;
            padding-left: 30px;
            background: url('./img/bottom-title.png');
            background-size: 100% 100%;
            background-position: left;
            background-repeat: no-repeat;

        }

        &_conter {
            flex: 1;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            background: url('./img/bottom-conter.png');
            background-size: 100% 100%;
            background-position: left;
            background-repeat: no-repeat;

            &_yuan {
                position: absolute;
                width: 70%;
                height: 70%;
                display: flex;
                align-items: center;
                justify-content: center;
                animation: scanning 10s linear infinite;

                &:hover {
                    animation-play-state: paused;
                    cursor: pointer;
                }

                img {
                    width: auto;
                    height: 100%;
                }
            }

            &_text {
                font-size: 14px;
            }
        }
    }
}

.stopSearch {
    animation-play-state: paused;
}

@keyframes scanning {
    to {
        transform: rotate(1turn);
    }
}
</style>
